/**
 * EventBus
 *
 * Global VUE instance to register events on.
 * Note: This is not a special library or anything, we're just using an empty VUE instance to call $emit and $on on.
 *
 * Usage in a component (the unsubscribe is important for avoiding memory leaks!):
 * .created() { EventBus.$on(EVENTBUS_TOPICS.EVENT_NAME, this.methodName); }
 * .beforeDestroy() {EventBus.$off(EVENTBUS_TOPICS.EVENT_NAME, this.methodName); }
 */

import Vue from 'vue';

export const EventBus = new Vue();
